var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLarrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "399B88CA-6804-477D-9CA9-79BB347EBFF1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RiseIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Job-Details",
    transform: "translate(-21.000000, -75.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F5F5F5",
    x: 0,
    y: 0,
    width: 1680,
    height: 1066
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#292929",
    x: 0,
    y: 60,
    width: 1680,
    height: 48
  }), /*#__PURE__*/React.createElement("g", {
    id: "arrow",
    transform: "translate(31.207107, 84.000000) rotate(-180.000000) translate(-31.207107, -84.000000) translate(21.000000, 75.000000)",
    fill: "#979797",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.46446609,14.9497475 C2.91218134,14.9497475 2.46446609,14.5020322 2.46446609,13.9497475 C2.46446609,13.3974627 2.91218134,12.9497475 3.46446609,12.9497475 L12.3634661,12.9492525 L12.363961,4.05025253 C12.363961,3.49796778 12.8116763,3.05025253 13.363961,3.05025253 C13.9162458,3.05025253 14.363961,3.49796778 14.363961,4.05025253 L14.363961,13.9497475 C14.363961,14.4625833 13.9779208,14.8852546 13.4805822,14.9430197 L13.363961,14.9497475 L3.46446609,14.9497475 Z",
    id: "Combined-Shape",
    transform: "translate(8.414214, 9.000000) rotate(-45.000000) translate(-8.414214, -9.000000) "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLarrow);
export default __webpack_public_path__ + "static/media/larrow.15c97ba086993ebcea5ae92ecd0eb59c.svg";
export { ForwardRef as ReactComponent };